import React, { useState, useEffect } from 'react';
import {compose} from "redux";
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import maintenanceImage from 'assets/images/default-maint-page.png';
import { Popover } from '@material-ui/core';
import {
  Typography,
  Button,
} from '@material-ui/core';
import { getWithToken } from 'api/network';
import { adminSwitchMaintenanceMode } from 'store/actions';

const styles = theme => ({
});

const Maintenance = ({ user, currentAppVersion, adminSwitchMaintenanceMode }) => {
    const [checkStatusVisible, setCheckStatusVisible] = useState(false);
    const userHasAdminRole = user.roles.administrator;

    useEffect(()=> {
      setTimeout(()=>{
        setCheckStatusVisible(true);
      }, 1800000)
    }, []);

    async function getServerVersion() {
      const response = await getWithToken(`/api/ping/version`);
      const serverVersion = await response.text();
      return serverVersion;
    }

    const onCheckStatus = async () => {
      try {
        const serverVersion = await getServerVersion();
        if (serverVersion !== currentAppVersion) {
          window.location.reload();
        } else {
          adminSwitchMaintenanceMode(false);
        }
      } catch(error) {
        console.log(error);
      }
    }

    return ([
            <div key='anchorDiv'
                style={{ 
                    background: 'gray', 
                    minHeight: '100vh', 
                    minWidth: '100vw',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: 1200, // highest is .MuiAppBar-root: 1100
                    opacity: 0.5
            }}/>
            ,
            <Popover  key='maintenancePopover'
                open
                anchorReference={"none"}
                style={{ 
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%'
                }}
            >
            <div style={{ 
                    display: 'flex',
                    padding: '30px 200px',
                    flexDirection: "column",
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%'
                }}>
                <img src={maintenanceImage} 
                alt='underScheduledMaintenance'
                style={{ 
                    maxWidth: '100%',
                    maxHeight: '100%'
                  }}/>
                  <Typography variant="body1" align="center">
                    This website is currently undergoing scheduled maintenance.<br/>
                    We should be back shortly.
                  </Typography>
                  {userHasAdminRole && 
                    <Button 
                      variant="contained"
                      color="primary"
                      style={{marginTop: '20px'}}
                      onClick={() => adminSwitchMaintenanceMode(false)}
                    >
                      Hide maintenance mode
                    </Button>
                  }
                  {checkStatusVisible &&
                    <Button
                    variant="contained"
                    color="inherit"
                    style={{marginTop: '40px'}}
                    onClick={onCheckStatus}  
                  >
                     Check status
                  </Button>
                  }
                  
            </div>
          </Popover>
        ])
};

const mapStateToProps = state => ({
  user: state.appState.user,
  currentAppVersion: state.adminState.currentAppVersion,
});

const mapDispatchToProps = (dispatch) => ({
  adminSwitchMaintenanceMode: (isEnabled) => dispatch(adminSwitchMaintenanceMode(isEnabled))
});

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
  )(Maintenance);